import React, { useEffect } from "react";
import img from "../../../Home/img_project/webp/2.webp";
import img2 from ".././../img_project/webp/project1/2.webp";
import img3 from ".././../img_project/webp/project1/3.webp";
import img4 from ".././../img_project/webp/project1/4.webp";
import img1 from ".././../img_project/webp/project1/1.webp";

const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectPiscineOlympique() {

  useEffect(() => {
    document.title =
      "Piscine Olympique – Plafond acoustique haute performance | UNIK SYSTEM";

    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute(
      "content",
      "Installation d’un plafond tendu acoustique haute performance pour piscine olympique. Solution résistante à l’humidité avec traitement acoustique intégré."
    );
  }, []);

  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>

          <h1>
            Piscine Olympique <br /> Plafond acoustique haute performance
          </h1>

          <p>
            Installation d’un plafond tendu intégrant des textiles acoustiques
            haute performance pour améliorer le confort sonore et la durabilité
            dans un environnement humide.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : plafonds tendus, traitement acoustique,
            résistance à l’humidité.
          </p>

          <div className="pj-hero-actions">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-projet-piscine-olympique.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche projet
            </a>
          </div>
        </div>

        <div className="pj-hero-img">
          <img src={img} alt="Piscine olympique plafond acoustique" />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Réalisation d’un plafond acoustique pour une piscine olympique afin
          d’améliorer le confort sonore dans un environnement à forte
          réverbération et à forte humidité.
        </p>
        <p>
          L’objectif était de réduire les nuisances sonores tout en garantissant
          une solution durable, résistante au chlore et adaptée aux contraintes
          techniques d’un équipement sportif.
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Plafond tendu acoustique haute performance</li>
          <li>Textiles techniques résistants à l’humidité</li>
          <li>Traitement acoustique intégré</li>
          <li>Structure aluminium anticorrosion</li>
          <li>Finition durable adaptée aux piscines</li>
        </ul>
      </Block>

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Réduction significative de la réverbération</li>
          <li>Confort sonore amélioré pour les usagers</li>
          <li>Solution durable en environnement humide</li>
          <li>Esthétique moderne et homogène</li>
          <li>Maintenance simplifiée</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>
          Notre équipe technique vous accompagne de la conception à la pose.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
